<template>
  <div
    class="cus_status"
    :class="classes"
  >
    <slot></slot>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  item: {
    required: true,
    type: [Number, String],
  },
});

const classes = computed(() => {
  let className = '';
  switch (props.item) {
    case 1:
    case 2:
    case 5:
    case 6:
      className = 'yellow';
      break;
    case 3:
    case 7:
      className = 'blue';
      break;
    case 10:
      className = 'red';
      break;
    case 4:
    case 8:
    case 9:
    case 11:
      className = 'gray';
      break;
    default:
      break;
  }

  return className;
});
</script>
